import deckOfScarlet from './deck-of-scarlet'
import theHarmonist from './the-harmonist'


export const featuredBrandData: Record<BrandsModule.FeaturedBrand, BrandsModule.FeaturedBrandData> = {
  'deck-of-scarlet': deckOfScarlet,
  'the-harmonist': theHarmonist,
}
